import request from "@/utils/http";

// 获取检测项列表
export function checkItemList() {
  return request
    .get("/vehicle-check-report/check-item-list")
    .then(res => res.result);
}

// 添加车辆检测报告
export function vehicleCheckReport(data) {
  return request.post("/vehicle-check-report/add", data);
}
